export const MainPagePresenter = ({ children }) => children
